import styled from "styled-components";

export const BasicsInfoStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: auto;
  .linked-projects h6 {
    padding: 16px 0;
  }
  .header {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;

    .fields {
      display: flex;
      gap: 20px;
      > :first-child {
        margin-top: -20px;
      }
      align-items: center;
      .select {
        width: 180px;
      }
    }
  }
  /* .Mui-disabled {
    -webkit-text-fill-color: #080425 !important;
  } */
  .MuiInputBase-root.Mui-disabled {
    opacity: 1;
  }
  .selects {
    width: 150px;
    display: flex;
    gap: 10px;

    .MuiInputBase-root {
      background-color: #301d35;
      .MuiTypography-root {
        color: white;
        font-weight: bold;
      }
    }
    .css-16l2090-MuiSvgIcon-root-MuiSelect-icon {
      color: white;
    }
  }
  .create-cta {
    display: flex;
    gap: 16px;
    justify-content: end;
  }
  .plans {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 24px;
  }

  .invoice {
    display: flex;
    gap: 16px;
    padding: 16px;
    border-radius: 4px;
    border: 1px solid #dedafb;
    background: #efedfd;
  }
`;
